module.exports = __webpack_public_path__ + "img/demo8.3fd1b978.png";